<template>
    <LayoutPage>
        <template v-slot:banner>
            <SmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="$t('pricingPage.title')"
                :description="$t('pricingPage.description')"
            />
        </template>
        <template v-slot:content>
            <div class="box box--space-top">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">
                            <div class="row">
                                <div class="col-12 box box--center box--space-top">
                                    <span class="headline headline--primary pt-5">
                                        {{$t('pricingPage.contentHeading')}}
                                    </span>
                                    <span class="headline headline--fifth pt-4 ">
                                        {{$t('pricingPage.contentDescription')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="mm-section ">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">
                            <div class="text--basic-paragraph">
                                <div v-if="pricingPackages" class="">
                                    <div v-for="item in pricingPackages.data.packages"
                                        :key="item.id"
                                        class="box box--spaces box--space-bottom">

                                        <div class="row">
                                            <div class="col-md-5">
                                                <span class="headline headline--fifth mb-1">
                                                    {{$t('pricingPage.packageHeading')}}
                                                </span>

                                                <h2 class="headline headline--second headline--colored">
                                                    {{item.title}}
                                                </h2>

                                                <h5 class="headline headline--fifth headline--colored">
                                                    {{item.previewText}}
                                                </h5>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-5  box box--space-bottom2">
                                                <span class="headline headline--fifth">
                                                    {{$t('pricingPage.packageTargetHeading')}}
                                                </span>
                                                <p>
                                                    {{item.description}}
                                                </p>
                                                <div class="d-none d-md-block">
                                                    <div class="row">
                                                        <div class="col col-auto">
                                                            <p class="pt-2">
                                                            <strong style="font-size: 3rem">{{item.price}} </strong> <strong style="font-size: 2rem;">{{item.priceUnit}} / {{item.priceTimeUnit}}</strong>
                                                            </p>
                                                        </div>
                                                        <div class="col">
                                                            <button
                                                                v-if="item.operationType === 'buy'"
                                                                @click="() => addItemToBasket(item)"
                                                                class="button button button--wider-border button--small-text transparent--button button--uppercase button--float-left">
                                                                {{$t('pricingPage.choosePackage')}}
                                                            </button>
                                                            <button v-else
                                                                class="button primary--button">
                                                                {{$t('pricingPage.register')}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-1"></div>

                                            <div class="col-md-6 box box--space-bottom">
                                                <span class="headline headline--fifth">
                                                    {{$t('pricingPage.packageContentHeading')}}
                                                </span>
                                                <ul class="row">
                                                    <li class="col-sm-6"
                                                        v-for="f in item.features"
                                                        :key="f">
                                                        {{f}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col">
                                                <div class="d-block d-md-none">
                                                    <div class="box box--space-bottom">
                                                        <div class="box box--space-bottom-s">
                                                            <strong style="font-size: 3rem">{{item.price}} </strong> <strong style="font-size: 2rem;">{{item.priceUnit}} / {{item.priceTimeUnit}}</strong>
                                                        </div>
                                                        <button
                                                            v-if="item.operationType === 'buy'"
                                                            @click="() => addItemToBasket(item)"
                                                            class="button button button--wider-border button--small-text transparent--button button--uppercase button--float-left">
                                                            {{$t('pricingPage.choosePackage')}}
                                                        </button>
                                                        <button v-else
                                                            class="button primary--button">
                                                            {{$t('pricingPage.register')}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div v-else style="width: 100%" class="box box--center box--space-bottom">
                                    <app-spinner />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import webCMS from '@/services/WebCMS';
import LayoutPage from '@/components/layouts/Page';
import { addItemToBasket } from '../services/MapsfyApi';
import SmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
      SmallerWithSearchAndButton,
      LayoutPage
    },
    data() {
        return {
            items:  null,
            publicPath: process.env.BASE_URL,
            pricingRequestState: null,
            pricingPackages: null
        }
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadPricing();
    },
    methods: {
        addItemToBasket(product) {
            this.$router.push({name: 'mapApp'});
            addItemToBasket(product.id);
        },
        loadPricing() {
            this.pricingRequestState = "request";

            webCMS.getPricingPackages(this.axios)
                .then(res => {
                    this.pricingPackages = res;
                    this.pricingRequestState = "success";
                })
                .catch(() => {
                    this.pricingRequestState = "failure";
                });
        }

    }
}
</script>
